// How good a move was: the one grade the whole app shows for a move, so a
// move the Blunders screen lists is a blunder on the scoresheet, the board
// and every chart too. The user's rules (Settings → Mistakes) decide the two
// that are listed, blunder and miss (`moveKindOf`); the scan's fixed steps
// (`judge`) grade the rest. A loss the fixed steps call a blunder but the
// rules do not is a mistake, so no grade ever says blunder where the rules
// say otherwise.
import { MOVE_GRADES, type MoveGrade, type MoveJudgement, type MoveKind } from '@chess/api-model';

export { MOVE_GRADES, type MoveGrade };

export const MOVE_GRADE_LABEL: Record<MoveGrade, string> = {
  best: 'Best move',
  good: 'Good move',
  inaccuracy: 'Inaccuracy',
  mistake: 'Mistake',
  blunder: 'Blunder',
  miss: 'Miss',
};

/**
 * The grade of a judged move, given its kind under the rules (`moveKindOf`,
 * `GameScan.kind`): the kind when there is one, else the judgement's own
 * grade, a fixed-step blunder the rules do not count becoming a mistake.
 */
export function moveGradeOf(judgement: MoveJudgement | undefined, kind: MoveKind | undefined): MoveGrade | undefined {
  if (!judgement) return undefined;
  if (kind) return kind;
  return judgement.judgement === 'blunder' ? 'mistake' : judgement.judgement;
}
